import { Offer_Engagement_Type } from '@occc/graphql';

import { OfferType } from '../types';
import { offerTypeToEngagementTypeMap, engagementTypeToOfferTypeMap } from '../constants';

class OfferUtils {
  getOfferTypeByEngagementType(engagementType: Offer_Engagement_Type) {
    const offerType = engagementTypeToOfferTypeMap[engagementType];
    return offerType || null;
  }

  getEngagementTypeByOfferType(offerType: OfferType) {
    const engagementType = offerTypeToEngagementTypeMap[offerType];
    return engagementType || null;
  }
}

export const offerUtils = new OfferUtils();
